import React from 'react';

const UserTitle = ({ record }) => (
   <span>
      {record ? record.username : ''}
   </span>
);

export default UserTitle;
